
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"56","height":"22","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"56","height":"22","rx":"4","fill":"#B7BEC5"}}),_c('path',{attrs:{"d":"M9.736 16V5.864h3.01c3.099 0 4.648 1.078 4.648 3.234 0 1.139-.401 1.97-1.204 2.492-.793.523-1.97.784-3.528.784h-.7V16H9.736zm2.226-5.432h.812c.896 0 1.517-.103 1.862-.308.355-.215.532-.565.532-1.05 0-.541-.191-.91-.574-1.106-.373-.196-.999-.294-1.876-.294h-.756v2.758zM18.677 16V5.864h3.01c3.1 0 4.648 1.078 4.648 3.234 0 1.139-.4 1.97-1.204 2.492-.793.523-1.969.784-3.527.784h-.7V16h-2.227zm2.227-5.432h.811c.896 0 1.517-.103 1.863-.308.354-.215.532-.565.532-1.05 0-.541-.192-.91-.575-1.106-.373-.196-.998-.294-1.875-.294h-.756v2.758zM30.18 16V7.81h-3.276V5.864h8.778V7.81h-3.276V16H30.18zm5.477 0l3.696-5.418-3.178-4.718h2.604l.91 1.386c.345.523.719 1.106 1.12 1.75h.014c.355-.579.723-1.157 1.106-1.736l.91-1.4h2.492l-3.178 4.718L45.864 16h-2.646l-1.442-2.17a70.82 70.82 0 01-1.064-1.652h-.028c-.243.392-.593.938-1.05 1.638L38.192 16h-2.534z","fill":"#fff"}})])
          )
        }
      }
    